export default __webpack_public_path__ + "static/media/White0006.17a1bede.png";